import React, { useState, useEffect } from 'react';
import Section from '../Section';
import BlogSectionStyle2 from '../Section/BlogSection/BlogSectionStyle2';
import Breadcrumb from '../Breadcrumb';
import { pageTitle } from '../../helpers/PageTitle';
import client from '../../sanityClient';

export default function Resources() {
  pageTitle('News and Updates');

  const postsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const [allPosts, setAllPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState(null);

  useEffect(() => {
    // Fetch posts, filtering by selectedTag
    client
      .fetch(
        `*[_type == "post" && publishedAt <= now() && ($tag == null || $tag in tags[])] 
         | order(publishedAt desc){
           title,
           publishedAt,
           slug,
           coverImage{
             asset->{_id, url},
             alt
           },
           tags
         }`,
        { tag: selectedTag }
      )
      .then((data) => {
        setAllPosts(data);
        setLoading(false);
      })
      .catch(console.error);
  }, [selectedTag]);  // refetch when tag changes

  const totalPages = Math.ceil(allPosts.length / postsPerPage);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = allPosts.slice(indexOfFirstPost, indexOfLastPost);

  if (loading) return <p>Loading posts...</p>;

  // return (
  //   <>
  //     <Section topMd={170} bottomMd={96} bottomLg={70}>
  //       <Breadcrumb title="News and Updates" />
  //     </Section>
  //     <Section bottomMd={200} bottomLg={150} bottomXl={110}>
  //       <BlogSectionStyle2
  //         data={currentPosts}
  //         currentPage={currentPage}
  //         totalPages={totalPages}
  //         setCurrentPage={setCurrentPage}
  //       />
  //     </Section>
  //   </>
  // );

   return (
    <>
      <Section topMd={170} bottomMd={48} bottomLg={35}>
        <Breadcrumb title="News and Updates" />
      </Section>
      
      {/* Tag filter UI */}
      <Section  bottomMd={48} bottomLg={35}>
        <div className="container">
          <div className="tag-filter-container">
            <button
              className={selectedTag === null ? 'active' : ''}
              onClick={() => {
                setSelectedTag(null);
                setCurrentPage(1);
              }}
            >
              All
            </button>
          {/** Here, gather unique tags from allPosts or maintain a separate list of tags */}
          {Array.from(new Set(allPosts.flatMap(p => p.tags || []))).map(tag => (
            <button
              key={tag}
              className={selectedTag === tag ? 'active' : ''}
              onClick={() => {
                setSelectedTag(tag);
                setCurrentPage(1);
              }}
            >
              {tag}
            </button>
        ))}
        </div>
        </div>
        
      </Section>
      

      <Section bottomMd={200} bottomLg={150} bottomXl={110}>
        <BlogSectionStyle2
          data={currentPosts}
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
        />
      </Section>
    </>
  );
}
